import React, { useLayoutEffect, useRef } from 'react'
import './JackpotFly.css'

// The won ACUMULADO travelling from the header pot down into the footer's
// "Ganhou" box, so the player SEES the jackpot being added to the win. This is
// the path the user traced with a finger in public/ice-assets/jackpot-amount.mp4:
// header "R$ 500.0" straight down to the message box beside GIRAR.
//
// Both ends are measured from the live DOM (the header value and the footer
// message), so the flight lands on the box at any screen size. The header value
// itself stays put — the user does not want the pot to vanish up there.
const FLY_MS = 1400

// `small`: one of a fast stream (the pot coming down 1 by 1), so it grows less,
// wanders a little sideways like the coins, and the box's pop is a light tap.
function JackpotFly({ amount, small = false, onArrive }) {
    const ref = useRef(null)
    const onArriveRef = useRef(onArrive)
    onArriveRef.current = onArrive

    useLayoutEffect(() => {
        const el = ref.current
        const from = document.querySelector('.ice-hd-acum-val b')
        const to = document.querySelector('.ice-credits-text')
        if (!el || !from || !to) {
            onArriveRef.current && onArriveRef.current()
            return undefined
        }
        const a = from.getBoundingClientRect()
        const b = to.getBoundingClientRect()
        el.style.fontSize = getComputedStyle(from).fontSize
        const w = el.offsetWidth
        const h = el.offsetHeight
        const x0 = a.left + a.width / 2 - w / 2
        const y0 = a.top + a.height / 2 - h / 2
        const x1 = b.left + b.width / 2 - w / 2
        const y1 = b.top + b.height / 2 - h / 2
        const drift = small ? (Math.random() - 0.5) * a.width * 2 : 0
        const at = (k) => `translate(${x0 + (x1 - x0) * k + drift * Math.sin(Math.PI * k)}px, ${y0 + (y1 - y0) * k}px)`
        const grow = small ? 1.3 : 1.8

        // lifts off the pot, grows so it reads clearly over the reels, then
        // drops into the box
        const flight = el.animate([
            { transform: `${at(0)} scale(1)`, opacity: 1 },
            { transform: `${at(0.08)} scale(${grow * 0.85})`, opacity: 1, offset: 0.15 },
            { transform: `${at(0.6)} scale(${grow})`, opacity: 1, offset: 0.6 },
            { transform: `${at(1)} scale(1)`, opacity: 1, offset: 0.92 },
            { transform: `${at(1)} scale(0.9)`, opacity: 0 },
        ], { duration: FLY_MS, easing: 'ease-in-out', fill: 'forwards' })

        flight.onfinish = () => {
            // the box answers the landing with a pop
            to.animate([
                { transform: 'scale(1)' },
                { transform: `scale(${small ? 1.08 : 1.3})` },
                { transform: 'scale(1)' },
            ], { duration: small ? 200 : 450, easing: 'ease-out' })
            onArriveRef.current && onArriveRef.current()
        }
        return () => { flight.onfinish = null; flight.cancel() }
    }, [small])

    return (
        <div ref={ref} className='ice-jackpot-fly' aria-hidden='true'>
            {Number.isInteger(amount) ? amount : Number(amount || 0).toFixed(1)}
        </div>
    )
}

export default JackpotFly
